import React, { useEffect} from "react";
import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';

const Logout = ({ logout }) => {
    useEffect(() => { 
        logout();
        window.location.href = '/';
        // navigate('/sign-in');
	},[])
    

    

// console.log('profile', profile)
    return (
        <div>
        

        </div>
    );
}

function mapStateToProps(state) {
    return {
        loggedIn: state.customer.loggedIn
    };
}

function mapDispatchToProps(dispatch) {
    return {
       logout: () => dispatch(actions.logout())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);